import { Injectable, Optional, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject, of } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { RuntimeConfig, RuntimeConfigInjectionToken } from './runtime-config';

@Injectable()
export class RuntimeConfigLoaderService {
	private fileUrl: string = './assets/config.json';
	private configObject;
  private _configuration = new Subject<any>();
  public changed = this._configuration.asObservable();

	constructor(private _http: HttpClient, @Optional() @Inject(RuntimeConfigInjectionToken) config: RuntimeConfig) {
		if (config) {
			this.fileUrl = config.fileUrl || this.fileUrl;
		}
	}

	loadConfig(): Promise<any> {
	  return this._http
	    .get(this.fileUrl)
	    .pipe(
	      tap(response => {
	        this.configObject = response;
	        this._configuration.next(this.configObject);
	      }),
	      catchError(err => {
	        this.configObject = null;
	        this._configuration.next(this.configObject);
	        return of(null);
	      })
	    )
	    .toPromise();
	}

	getConfig() {
		return this.configObject;
	}
}
